import './Footer.css';

function Footer() {
  
  return (
    <div className="footer">
      <p className="copyright">Designed by K. C. Chandler, 2021</p>
    </div>
  )
}
export default Footer;